module.exports = __webpack_public_path__ + "img/icon_about_11.b12db780.png";